import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Tools from "../views/Tools.vue";

import PortOrders from "../views/tools/portorders/Index.vue";
import LicenseAddressEditor from "../views/tools/licenseaddresseditor/Index.vue";
import SmsAudit from "../views/tools/smsaudit/Index.vue";

import {
  TAP_TOOLS_FRAUD_SUPPORT,
  TAP_TOOLS_PS,
  TAP_TOOLS_SUPER,
  TAP_TOOLS_SUPPORT,
  TAP_TOOLS_THOR,
} from "@/react/services/rbac/groups";
import * as PATHS from "@/react/routing/constants";
import { addEventListener, EVENT_TYPES } from "@/events";

export const ROUTE_HOME = "Home";

export const routes = [
  {
    path: "/",
    name: ROUTE_HOME,
    component: Home,
    meta: {
      icon: "HomeIcon",
      requiresAuth: true,
      groups: [],
    },
  },
  {
    path: PATHS.BULK_SERVICES,
    name: "Bulk Services",
    component: Tools,
    meta: {
      icon: "TemplateIcon",
      requiresAuth: true,
      groups: [TAP_TOOLS_SUPER, TAP_TOOLS_SUPPORT, TAP_TOOLS_PS],
    },
    children: [
      {
        path: "pbx/",
        name: "PBX",
        meta: {
          icon: "PBXIcon",
          requiresAuth: true,
          requiresCustomerToken: false,
          requiresPbx: false,
          groups: [TAP_TOOLS_SUPER, TAP_TOOLS_PS, TAP_TOOLS_SUPPORT],
        },
      },
      {
        path: "port-orders",
        name: "Port Orders",
        meta: {
          icon: "DeskPhoneIcon",
          requiresAuth: true,
          groups: [TAP_TOOLS_SUPER, TAP_TOOLS_PS],
        },
        component: PortOrders,
        props: { title: "Bulk Manual Port Orders" },
      },
    ],
  },
  {
    path: PATHS.SUPPORT_TOOLS,
    name: "Support Tools",
    component: Tools,
    meta: {
      icon: "AttendantIcon",
      requiresAuth: true,
      groups: [
        TAP_TOOLS_SUPER,
        TAP_TOOLS_PS,
        TAP_TOOLS_THOR,
        TAP_TOOLS_SUPPORT,
      ],
    },
    children: [
      {
        path: "lae",
        name: "License Address Editor",
        meta: {
          icon: "AddressBookIcon",
          requiresAuth: true,
          groups: [TAP_TOOLS_SUPER, TAP_TOOLS_PS, TAP_TOOLS_SUPPORT],
        },
        component: LicenseAddressEditor,
        props: { title: "License Address Editor" },
      },
    ],
  },
  {
    path: "/fraud-support",
    name: "Fraud Support",
    component: Tools,
    meta: {
      icon: "BullhornIcon",
      requiresAuth: true,
      groups: [TAP_TOOLS_SUPER, TAP_TOOLS_FRAUD_SUPPORT],
    },
    children: [
      {
        path: "sms-audit",
        name: "SMS Audit",
        meta: {
          icon: "LiveMonitorIcon",
          requiresAuth: true,
          groups: [TAP_TOOLS_SUPER, TAP_TOOLS_FRAUD_SUPPORT],
        },
        component: SmsAudit,
        props: { title: "SMS Audit" },
      },
    ],
  },
  {
    path: "*",
    name: "toReact",
    template: "",
    meta: {
      requiresAuth: false,
      reactRoute: true,
    },
  },
];

export const router = new VueRouter({
  mode: "history",
  routes,
});

addEventListener(EVENT_TYPES.SYNC_VUE_ROUTE, (e) => {
  const { detail: path } = e;
  router.replace(path).catch(() => true);
});

Vue.use(VueRouter);
